export default{
    getLocations(state){
        return state.locationsOptions
    },
    getJournalists(state){
        return state.journalistsOptions
    },
}